<template>
  <div class="canvas-stars">
    <canvas class="stars" ref="starsCanvas"></canvas>
  </div>
</template>
<script>
export default {
  name: "canvasStars",
  props: {
    animProg: Boolean,
    twinkleRate: Number,
    numStars: {
        type: Number,
        default: 20
    },

  },

  data() {
    return {
      stars_cx: null,
      cx: null,
      rectX: 0,
      request: null,
      stars: [],
      animStage: 0,
      animStars: true,


      // animstage 0 inactive inivisible
      // animstage 1 visible
      // animstage 3 active visible
    };
  },

  mounted() {
    this.initCanvas();
    this.createStars();
    this.drawCanvas();
    this.performStarsAnim();

  },
  beforeDestroy() {
    this.animStage = 0;
    this.animStars = false;
    this.performStarsAnim = null;
  },

  methods: {
    initCanvas() {
      this.stars_cx = this.$refs.starsCanvas;
      this.stars_cx.width = this.$refs.starsCanvas.parentElement.clientWidth;
      this.stars_cx.height = this.$refs.starsCanvas.parentElement.clientHeight;
      this.cx = this.stars_cx.getContext("2d", { alpha: false });
      this.cx.fillRect(0, 0, this.stars_cx.width, this.stars_cx.height);
      this.cx.fillStyle = "#000";
    },

    createStars() {
      for (let i = 0; i < this.numStars; i++) {
        let star = {};

        star.x = Math.floor(Math.random() * this.canvasWidth);
        star.y = Math.floor(Math.random() * this.canvasHeight);
        star.size = Math.floor(Math.random() * 3);
        star.col = Math.floor(Math.random() * 40) + 60;

        this.stars.push(star);
      }
    },

    drawStars(y) {
      this.cx.fillStyle = "hsla( 255,100%," + this.stars[y].col + "%,1)";
      this.cx.fillRect(
        this.stars[y].x,
        this.stars[y].y,
        this.stars[y].size,
        this.stars[y].size
      );
    },

    clearCanvas() {
      this.cx.fillStyle = "#000";
      this.cx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
    },

    drawCanvas() {
      for (let i = 0; i < this.stars.length; i++) {
        this.drawStars(i);
      }
    },

    updateCanvas() {
      for (let i = 0; i < this.stars.length; i++) {
        if (Math.random() > 1 - (this.twinkleRate * 0.01)) {

          if (Math.random() > 0.8) {
            this.stars[i].col -= 10;
            if (this.stars[i].col < 60) {
              this.stars[i].col += 10;
            }
          } else {
            this.stars[i].col += 10;
            if (this.stars[i].col > 100) {
              this.stars[i].col -= 10;
            }
          }
        }
      }
    },
    performStarsAnim() {
      this.clearCanvas();
      this.drawCanvas();
      this.updateCanvas();

      // console.log('stars running');
      if (this.animStars === false) return;
      requestAnimationFrame(this.performStarsAnim);
    }
  },

  computed: {
    canvasWidth() {
      return this.stars_cx.width;
    },
    canvasHeight() {
      return this.stars_cx.height;
    },


  },
  watch: {
    animProg(newval) {
             if (newval === true) {
        requestAnimationFrame(this.performStarsAnim);
      } else {
        cancelAnimationFrame(this.performStarsAnim);
      }

    }


  }
};
</script>

<style lang="scss">
.canvas-stars {
  width: 100%;
  height: 100%;
  opacity: 1;
  position: absolute;
  transition: opacity 3s ease-in;


  .stars {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
